import { axiosInstance } from "libs/axiosInstance";

import type { TAnalysisItemInfo } from "api/@scalp/scalp_types";
import type {
  TGetTopRankedShampooListRes,
  TGetShampooListRes,
  TPostShampooResultRes,
  TGetShampooIngredientInfoListRes,
  TGetShampooInfoRes,
} from "./shampoo_type";

//나에게 맞는 상위 5개 샴푸
export const getTopRankedShampooList = async ({
  user_id,
  diagnosis_items,
  size,
}: {
  user_id: string;
  diagnosis_items: TAnalysisItemInfo | null;
  size: number;
}) => {
  if (diagnosis_items) {
    const res = await axiosInstance.post<TGetTopRankedShampooListRes>(
      `/shampoo/my/${user_id}/shampoo-ranks/with-scalp`,
      {
        size: size,
        scalp_diagnosis_items: diagnosis_items,
      },
    );
    return res.data;
  } else {
    const res = await axiosInstance.get<TGetTopRankedShampooListRes>(
      `/shampoo/my/${user_id}/shampoo-ranks?size=${size}`,
    );
    return res.data;
  }
};

// 샴푸 리스트 조회
export const getShampooList = async () => {
  const res = await axiosInstance.get<TGetShampooListRes>("/shampoo/list");

  return res.data;
};

// 샴푸 단일조회
export const getShampooInfo = async (shampooId: string) => {
  const res = await axiosInstance.get<TGetShampooInfoRes>(`/shampoo/${shampooId}`);

  return res.data;
};

// 샴푸 좋아요
export const postLikeShampoo = async (shampooId: number) => {
  const res = await axiosInstance.post(`/shampoo/like/${shampooId}`);

  return res.data;
};

// 샴푸 싫어요
export const postUnLikeShampoo = async (shampooId: number) => {
  const res = await axiosInstance.post(`/shampoo/unlike/${shampooId}`);

  return res.data;
};

// 샴푸 분석 결과
export const postShampooResult = async ({
  user_id,
  product_id,
  diagnosis_items,
}: {
  user_id: number;
  product_id: number;
  diagnosis_items: TAnalysisItemInfo | null;
}) => {
  if (diagnosis_items) {
    const res = await axiosInstance.post<TPostShampooResultRes>(`/shampoo/analysis/with-scalp`, {
      user_id: user_id,
      product_id: product_id,
      scalp_diagnosis_items: diagnosis_items,
    });
    return res.data;
  } else {
    const res = await axiosInstance.post<TPostShampooResultRes>(`/shampoo/analysis/with-passthrough`, {
      user_id: user_id,
      product_id: product_id,
    });
    return res.data;
  }
};

// 샴푸 전성분
export const getShampooIngredientInfoList = async (user_id: string, analysis_id: string) => {
  const res = await axiosInstance.get<TGetShampooIngredientInfoListRes>(
    `/shampoo/my/${user_id}/result/${analysis_id}/ingredients`,
  );
  return res.data;
};

export const getOwnProducts = () => {
  return axiosInstance.get(`/shampoo/own-products`);
};

// 사용자 퀴즈 등록
export const submitQuiz = ({ quizzes, user_id }: { quizzes: any; user_id: string }) => {
  return axiosInstance.post(`/my/account/user/${user_id}/quiz`, { quizzes });
};
